export const embryologyInitialData = {
  ivf_flow_id: "",
  eggs: null,
  cycle_type: null,
  cycle_no: "",
  icsi_ivf_done_by_other: "",
  tesa_pesa_done_by_other: "",
  opu_done_by_other: "",
  assisted_by_other: "",
  anesthesia_given_by: null,
  denudation_done_by: null,
  anesthesia_given_by_other: "",
  denudation_done_by_other: "",
  donor_partner_name: "",
  donor_partner_age: "",
  sperms: null,
  sperms_by: null,
  sperms_quality: null,
  sperms_quality_donor: null,
  sperms_quality_other_donor: "",
  sperms_prep_method_donor: null,
  sperms_prep_method_other_donor: "",
  sperms_donor: null,
  sperms_by_donor: null,
  frozen_vial_id_donor: "",
  sperms_prep_method: null,
  add_on: null,
  frozen_vial_id: "",
  icsi_ivf_done_by: null,
  tesa_pesa_done_by: null,
  opu_done_by: null,
  assisted_by: null,
  opu_date: null,
  opu_time: null,
  actual_opu_time: null,
  amh: "",
  gv: "",
  progesterone: "",
  lmp: "",
  lh: "",
  e2: "",
  atretic: "",
  embryo_dev_pgt: null,
  denudation_time: null,
  icsi_ivf_time: null,
  embryo_dev_culture_media: null,
  embryo_dev_culture_media_other: null,
  freezing_media_other: null,
  vitrification_devices_other: null,
  add_on_other: "",
  embryo_dev_batch_no: "",
  embryo_dev_expiry_date: null,
  day_0_date: null,
  day_0_time: null,
  day_1_date: null,
  day_0_hrs_post_icsi: "",
  day_3_date: null,
  day_3_time: null,
  day_5_date: null,
  day_6_date: null,
  day_7_date: null,
  vitrification_batch_no_exp_date: "",
  freezing_media: null,
  vitrification_devices: null,
  vitrification_batch_no: "",
  vitrification_expiry_date: null,
  pre_frozen_embryo_available: null,
  tank_no: "",
  cannister_no: "",
  thawing_media: null,
  embryo_dev_incubator_other: "",
  warming_expiry_date: null,
  distance_from_fundus: "",
  transfer_done_by: null,
  total_straw: 0,
  total_goblet: 0,
  embryo_loading_by: null,
  embryo_dev_incubator: null,
  sperms_prep_method_other: "",
  sperms_quality_other: "",
  embryo_dev_batch_no_exp_date: "",
  notes: "",
  no_of_oocytes: "",
  cleaved: "",
  degenerated: "",
  unfert: "",
  abnormal_pn: "",
  kept_for_blastocyst: "",
  eggs_to: [],
  eggs_by: [],
  eggs_by_ivf_id: [],
  eggs_donor: null,
  eggs_to_donor: [],
  eggs_by_ivf_id_donor: [],
  eggs_by_donor: [],
};

export const procedureDetailsInitialData = {
  anesthesia_given_by: null,
  anesthesia_given_by_other: "",
  opu_done_by: null,
  opu_done_by_other: "",
  tesa_pesa_done_by: null,
  tesa_pesa_done_by_other: "",
  denudation_done_by: null,
  denudation_done_by_other: "",
  icsi_ivf_done_by: null,
  icsi_ivf_done_by_other: "",
  assisted_by: null,
  lmp: "",
  opu_date: null,
  opu_time: null,
  actual_opu_time: null,
  denudation_time: null,
  icsi_ivf_time: null,
  lh: "",
  e2: "",
  embryo_dev_incubator: null,
  embryo_dev_incubator_other: "",
  embryo_dev_culture_media: null,
  embryo_dev_culture_media_other: null,
  embryo_dev_batch_no_exp_date: "",
  embryo_dev_pgt: null,
  add_on: null,
  progesterone: "",
  amh: "",
  day_0_date: null,
  day_0_time: null,
  day_0_hrs_post_icsi: "",
  day_1_date: null,
  day_3_date: null,
  day_5_date: null,
  day_6_date: null,
  day_7_date: null,
  freezing_media: null,
  freezing_media_other: null,
  vitrification_batch_no_exp_date: "",
  vitrification_devices: null,
  vitrification_devices_other: null,
  total_goblet: 0,
  total_straw: 0,
  tank_no: "",
  cannister_no: "",
  oocytes: [],
};

export const assignEDSTableEmptyValueFields = [
  "stage_of_development",
  "embryo_grade",
  "blasto_score",
  "rating",
  "et_status",
  "provider",
  "provider_other",
  "introducer",
  "introducer_other",
  "complication",
  "date_of_freezing",
  "vitrification_id",
  "straw_color",
  "straw_color_other",
  "goblet_color",
  "goblet_color_other",
  "vitrified_by",
  "status",
  "well_no",
];

export const days = {
  D2: 2,
  D3: 3,
  D5: 5,
  D6: 6,
  D7: 7,
};

export const isOpenBy = ["Donor Thawed", "Donor Fresh"];

export const isOpenTo = ["Professional Donor"];

export const validScores = [
  "111",
  "112",
  "113",
  "121",
  "122",
  "123",
  "131",
  "132",
  "133",
  "211",
  "212",
  "213",
  "221",
  "222",
  "223",
  "231",
  "232",
  "233",
  "311",
  "312",
  "313",
  "321",
  "322",
  "323",
  "331",
  "332",
  "333",
];

export const checkD5GoodValues = [
  "6AA",
  "6AB",
  "6BA",
  "5AA",
  "5AB",
  "5BA",
  "4AA",
  "4AB",
  "4BA",
  "3AA",
  "3AB",
  "3BA",
];

export const checkD5FairValues = ["6BB", "5BB", "4BB", "3BB"];

export const checkD5PoorValues = [
  "6CA",
  "6AC",
  "6CB",
  "6BC",
  "6CC",
  "5CA",
  "5AC",
  "5CB",
  "5BC",
  "5CC",
  "4CA",
  "4AC",
  "4CB",
  "4BC",
  "4CC",
  "3CA",
  "3AC",
  "3CB",
  "3BC",
  "3CC",
];

export const checkD6GoodValues = ["6AA", "5AA", "4AA"];

export const checkD6FairValues = [
  "6AB",
  "6BA",
  "6BB",
  "5AB",
  "5BA",
  "5BB",
  "4AB",
  "4BA",
  "4BB",
  "3AA",
  "3AB",
  "3BA",
];

export const checkD6PoorValues = [
  "6CA",
  "6AC",
  "6CB",
  "6BC",
  "6CC",
  "5CA",
  "5AC",
  "5CB",
  "5BC",
  "5CC",
  "4CA",
  "4AC",
  "4CB",
  "4BC",
  "4CC",
  "3CA",
  "3AC",
  "3CB",
  "3BC",
  "3CC",
  "3BB",
];

export const checkD7GoodValues = ["6AA", "5AA"];

export const checkD7FairValues = [
  "6AB",
  "6BA",
  "5AB",
  "5BA",
  "4AB",
  "4BA",
  "4AA",
];

export const checkD7PoorValues = [
  "6BB",
  "6CA",
  "6AC",
  "6CB",
  "6BC",
  "6CC",
  "5BB",
  "5CA",
  "5AC",
  "5CB",
  "5BC",
  "5CC",
  "4BB",
  "4CA",
  "4AC",
  "4CB",
  "4BC",
  "4CC",
  "3BB",
  "3CA",
  "3AC",
  "3CB",
  "3BC",
  "3CC",
  "3BA",
  "3AB",
  "3AA",
];

export const embryology_countTable = {
  reference_ivf_id: "",
  no_of_oocytes: "",
  total_m2: "",
  total_m2_used: null,
  total_m1: "",
  total_m1_used: null,
  gv: "",
  atretic: "",
  fert: "",
  cleaved: "",
  unfert: "",
  degenerated: "",
  kept_for_blastocyst: "",
  total_blastocyst: "",
  notes: "",
  patient_detail: {},
};

export const embryoTable = {
  oocytes: "",
  well_no: "",
  maturation_stage: null,
  fert_check: null,
  rating: "",
  incubator: null,
  stage_of_development: null,
  embryo_grade: null,
  blasto_score: null,
  date_of_freezing: null,
  note: "",
  vitrification_id: null,
  straw_color: null,
  goblet_color: null,
  status: null,
  vitrified_by: "",
  oocytes_quality: null,
  provider: null,
  complication: null,
  introducer: null,
  provider_other: null,
  introducer_other: null,
  straw_color_other: null,
  goblet_color_other: null,
};

export const clearEmbryologyDetailsData = {
  ivf_flow_id: "",
  eggs: null,
  cycle_type: null,
  cycle_no: "",
  opu_done_by: null,
  opu_done_by_other: "",
  anesthesia_given_by: null,
  denudation_done_by: null,
  anesthesia_given_by_other: "",
  denudation_done_by_other: "",
  tesa_pesa_done_by: null,
  donor_partner_name: "",
  donor_partner_age: "",
  sperms: null,
  sperms_quality: null,
  sperms_prep_method: null,
  add_on: null,
  frozen_vial_id: "",
  icsi_ivf_done_by: null,
  assisted_by: null,
  opu_date: null,
  opu_time: null,
  actual_opu_time: null,
  amh: "",
  progesterone: "",
  lmp: "",
  lh: "",
  e2: "",
  atretic: "",
  embryo_dev_pgt: null,
  denudation_time: null,
  icsi_ivf_time: null,
  embryo_dev_culture_media: null,
  embryo_dev_culture_media_other: null,
  freezing_media_other: null,
  vitrification_devices_other: null,
  icsi_ivf_done_by_other: "",
  sperms_prep_method_other: "",
  sperms_quality_other: "",
  assisted_by_other: "",
  embryo_dev_batch_no_exp_date: "",
  tesa_pesa_done_by_other: "",
  add_on_other: "",
  embryo_dev_batch_no: "",
  embryo_dev_expiry_date: null,
  day_0_date: null,
  day_0_time: null,
  day_1_date: null,
  day_0_hrs_post_icsi: "",
  day_3_date: null,
  day_3_time: null,
  day_5_date: null,
  day_6_date: null,
  day_7_date: null,
  vitrification_batch_no_exp_date: "",
  freezing_media: null,
  vitrification_devices: null,
  vitrification_batch_no: "",
  vitrification_expiry_date: null,
  pre_frozen_embryo_available: null,
  // no_of_goblet: "",
  tank_no: "",
  // no_of_straws: "",
  cannister_no: "",
  thawing_media: null,
  embryo_dev_incubator_other: "",
  warming_expiry_date: null,
  distance_from_fundus: "",
  transfer_done_by: null,
  total_straw: 0,
  total_goblet: 0,
  embryo_loading_by: null,
  embryo_dev_incubator: null,
  total_m1: 0,
  total_m2: 0,
  cleaved: 0,
  degenerated: 0,
  unfert: 0,
  abnormal_pn: 0,
  kept_for_blastocyst: 0,
  no_of_oocytes: 0,
  notes: "",
  eggs_donor: null,
  eggs_to_donor: [],
  eggs_by_ivf_id_donor: [],
  eggs_to: [],
  eggs_by_ivf_id: [],
  eggs_by_donor: [],
  eggs_by: [],
};

export const icsiDoneByEmbryoTable = [
  {
    label: "Dr. Prabhakar Singh",
    value: "Dr. Prabhakar Singh",
  },
  {
    label: "Ram Prakash",
    value: "Ram Prakash",
  },
  {
    label: "Dhruti Bhatt",
    value: "Dhruti Bhatt",
  },
  {
    label: "Shraddha Mandaviya",
    value: "Shraddha Mandaviya",
  },
  {
    label: "Isha Mehta",
    value: "Isha Mehta",
  },
  {
    label: "Janki Choksi",
    value: "Janki Choksi",
  },
  {
    label: "Jignasha Vekariya",
    value: "Jignasha Vekariya",
  },
  {
    label: "Mohammad Masi",
    value: "Mohammad Masi",
  },
];

// export const icsiDoneByEmbryoTable = [
//   {
//     label: "Dr. Prabhakar",
//     value: "Dr. Prabhakar",
//   },
//   {
//     label: "Dr Vanita Viradiya",
//     value: "Dr Vanita Viradiya",
//   },
//   {
//     label: "Gaurav Thakur",
//     value: "Gaurav Thakur",
//   },
//   {
//     label: "Janki Choksi",
//     value: "Janki Choksi",
//   },
//   {
//     label: "Mahesh Vishwakarma",
//     value: "Mahesh Vishwakarma",
//   },
//   {
//     label: "Nikita Daswani",
//     value: "Nikita Daswani",
//   },
//   {
//     label: "Krupa Prajapati",
//     value: "Krupa Prajapati",
//   },
//   {
//     label: "Neha Thakor",
//     value: "Neha Thakor",
//   },
//   {
//     label: "Dr Birva Dave",
//     value: "Dr Birva Dave",
//   },
//   {
//     label: "Mahipal",
//     value: "Mahipal",
//   },
//   {
//     label: "Dr Yuvrajsingh Jadeja",
//     value: "Dr Yuvrajsingh Jadeja",
//   },
//   {
//     label: "Dr Pooja Nadkarni",
//     value: "Dr Pooja Nadkarni",
//   },
//   {
//     label: "Shraddha Mandaviya",
//     value: "Shraddha Mandaviya",
//   },
//   {
//     label: "PRIYANKA RAJPUT",
//     value: "PRIYANKA RAJPUT",
//   },
//   { label: "JIGNASHA VEKARIYA", value: "JIGNASHA VEKARIYA" },
// ];

export const exportPrintOptions = [
  {
    label: "PDF",
    value: "pdf",
  },
  {
    label: "Word",
    value: "word",
  },
];

export const disabledFields = {
  anesthesia_given_by: ["OD", "ED", "Thawed oocyte ICSI"],
  opu_done_by: ["OD", "ED", "Thawed oocyte ICSI", "FET+Surrogacy"],
  opu_date: ["OD", "ED", "Thawed oocyte ICSI", "FET+Surrogacy"],
  opu_time: ["OD", "ED", "Thawed oocyte ICSI", "FET+Surrogacy"],
  actual_opu_time: ["OD", "ED", "Thawed oocyte ICSI", "FET+Surrogacy"],
  denudation_time: ["OD", "ED", "Thawed oocyte ICSI", "FET+Surrogacy"],
  lh: ["OD", "ED", "Thawed oocyte ICSI", "FET+Surrogacy"],
  e2: ["OD", "ED", "Thawed oocyte ICSI"],
  et_status: ["OD"],
  sperms: ["Professional Donor", "Oocytes Vitrification"],
  sperms_quality: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  sperms_prep_method: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  frozen_vial_id: [
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  sperms_donor: ["Professional Donor", "Oocytes Vitrification"],
  sperms_quality_donor: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  sperms_prep_method_donor: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  frozen_vial_id_donor: [
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  tesa_pesa_done_by: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  denudation_done_by: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    // "Oocytes Vitrification",
  ],
  icsi_ivf_done_by: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  assisted_by: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  lmp: ["ED", "FET+Surrogacy"],
  icsi_ivf_time: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    // "Oocytes Vitrification"
  ],
  amh: ["FET+Surrogacy", "Professional Donor", "Oocytes Vitrification"],
  add_on: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  embryo_dev_pgt: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  vitrification_batch_no_exp_date: ["ED", "FET+Surrogacy"],
  embryo_dev_culture_media: ["ED", "FET+Surrogacy"],
  embryo_dev_incubator: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_0_date: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_0_time: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_0_hrs_post_icsi: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_1_date: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_3_date: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_5_date: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_6_date: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  day_7_date: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  freezing_media: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  vitrification_devices: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  total_goblet: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  total_straw: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  tank_no: [
    "ED",
    "FET+Surrogacy",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  no_of_oocytes: ["ED", "FET+Surrogacy"],
  total_m2: ["ED", "FET+Surrogacy"],
  gv: ["ED", "FET+Surrogacy"],
  atretic: ["ED", "Professional Donor", "FET+Surrogacy"],
  fert: ["ED", "Professional Donor", "Oocytes Vitrification", "FET+Surrogacy"],
  cleaved: [
    "ED",
    "Professional Donor",
    "Oocytes Vitrification",
    "FET+Surrogacy",
  ],
  unfert: [
    "FET+Surrogacy",
    "ED",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  cannister_no: [
    "FET+Surrogacy",
    "ED",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  degenerated: [
    "FET+Surrogacy",
    "ED",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  total_blastocyst: [
    "FET+Surrogacy",
    "ED",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  kept_for_blastocyst: [
    "FET+Surrogacy",
    "ED",
    "Professional Donor",
    "Oocytes Vitrification",
  ],
  embryo_dev_batch_no_exp_date: ["FET+Surrogacy", "ED"],
  progesterone: ["ED", "Professional Donor", "Oocytes Vitrification"],
  // fert_check: ["Oocytes Vitrification"],
  // stage_of_development: ["Oocytes Vitrification"],
  // embryo_grade: ["Oocytes Vitrification"],
  // provider: ["Oocytes Vitrification"],
  // introducer: ["Oocytes Vitrification"],
  // complication: ["Oocytes Vitrification"],
  // date_of_freezing: ["Oocytes Vitrification"],
  // straw_color: ["Oocytes Vitrification"],
  // goblet_color: ["Oocytes Vitrification"],
  // vitrified_by: ["Oocytes Vitrification"],
  // status: ["Oocytes Vitrification"],
  // well_no: ["Oocytes Vitrification"],
};

export const getClassNameForValue = (value) => {
  switch (value) {
    case "Blue":
      return "select-blue";
    case "Blue⭐":
      return "select-blue";

    case "Light Blue":
      return "select-light-blue";
    case "Light Blue⭐":
      return "select-light-blue";

    case "Sky":
      return "select-sky";
    case "Sky⭐":
      return "select-sky";

    case "Green":
      return "select-green";
    case "Green⭐":
      return "select-green";

    case "Light Green":
      return "select-light-green";
    case "Light Green⭐":
      return "select-light-green";

    case "Pink":
      return "select-pink";
    case "Pink⭐":
      return "select-pink";

    case "Light Pink":
      return "select-light-pink";
    case "Light Pink⭐":
      return "select-light-pink";

    case "Yellow":
      return "select-yellow";
    case "Yellow⭐":
      return "select-yellow";

    case "Grey":
      return "select-grey";
    case "Grey⭐":
      return "select-grey";

    case "White":
      return "select-white";
    case "White⭐":
      return "select-white";

    case "Purple":
      return "select-purple";
    case "Purple⭐":
      return "select-purple";

    case "Brown":
      return "select-brown";
    case "Brown⭐":
      return "select-brown";

    case "Orange":
      return "select-orange";
    case "Orange⭐":
      return "select-orange";

    case "Red":
      return "select-red";
    case "Red⭐":
      return "select-red";
    case "Other":
      return "select-other";
    default:
      return "selected-color";
  }
};
